export default {
  namespaced: true,
  state: () => ({
    alertaGeral: {
      isVisivel: false,
      tipo: null,
      mensagem: null,
    },
  }),
  mutations: {
    TRIGGER_ALERTA_GERAL(state, { tipo, mensagem, isVisivel }) {
      state.alertaGeral.tipo = tipo;
      state.alertaGeral.mensagem = mensagem;
      state.alertaGeral.isVisivel = isVisivel;

      setTimeout(() => {
        state.alertaGeral.isVisivel = false;
      }, 5000);
    },
  },
  actions: {
    triggerAlertaGeral(context, payload) {
      payload.isVisivel = true;
      context.commit('TRIGGER_ALERTA_GERAL', payload);
    },

    triggerError(context, text) {
      context.dispatch('triggerAlertaGeral', {
        isVisivel: true,
        tipo: 'error',
        mensagem: text,
      });
    },

    triggerFormEmptyFieldsAlert(context) {
      const data = {
        isVisivel: true,
        tipo: 'error',
        mensagem: 'Preencha todos os campos obrigatórios',
      };

      context.commit('TRIGGER_ALERTA_GERAL', data);
    },

    triggerDataProcessError(context, payload) {
      const data = {
        isVisivel: true,
        tipo: 'error',
        mensagem: payload
          ? payload
          : 'Ops, parece que houve uma falha técnica. Tente repetir a operação em alguns minutos',
      };

      context.commit('TRIGGER_ALERTA_GERAL', data);
    },
  },
};
